import React from 'react';

const CustomButton = ({ text, onClick, disabled }) => {
  const buttonStyle = {
    width: '150px', // default width
    height: '40px', // default height
    backgroundColor: disabled ? '#ccc' : 'orange',
    color: 'white',
    border: 'none',
    borderRadius: '40px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '20px',
    
  };

  return (
    <button style={buttonStyle} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default CustomButton;
